<template>
  <span v-b-hover="hoverHandler" class="pb-2">
    {{ truncatedText }}
  </span>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      required: true,
      default: ''
    },
    maxSize: {
      type: Number,
      required: false,
      default: 25
    }
  },
  data () {
    return {
      isHovered: false
    }
  },
  computed: {
    truncatedText () {
      if (this.text.length <= this.maxSize) {
        return this.text
      }

      return this.isHovered ? this.text : this.text.slice(0, this.maxSize) + '...'
    }
  },
  methods: {
    hoverHandler (isHovered) {
      this.isHovered = isHovered
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/crm/details/ajuizamento/TextTruncate.vue